import {linkifyText} from '@/shared/lib/legal/linkifyText';

import {type TableItem} from './types';

type TableContentViewProps = {
  headers: TableItem['headers'];
  rows: TableItem['rows'];
};

function TableContentView({headers, rows}: TableContentViewProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse border border-stroke text-sm">
        {headers && (
          <thead>
            <tr className="bg-light-primary text-left font-bold">
              {headers.map((header) => (
                <th
                  className="border border-stroke px-2 py-1"
                  key={header}
                  scope="col"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr className="hover:bg-placeholder" key={`static-${rowIndex}`}>
              {row.map((cell, cellIndex) => (
                <td
                  className="border border-stroke px-2 py-1 align-top"
                  key={`static-${cellIndex}`}
                >
                  {linkifyText(cell)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TableContentView;
